import { render, staticRenderFns } from "./payCategory.vue?vue&type=template&id=4f818fab&"
import script from "./payCategory.vue?vue&type=script&lang=js&"
export * from "./payCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports